/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';
import App from './app.vue';
import { optionalChaining } from '@/scripts/utils';

// 可选链
Vue.prototype.$$ = optionalChaining;

require('./app.js');

const app = new Vue(App).$mount('#app');

export default app;
